"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VectorTile = void 0;
const MltDecoder_1 = require("../../src/decoder/MltDecoder");
const VectorTileLayer_1 = require("./VectorTileLayer");
class VectorTile {
    constructor(data, featureTables) {
        this.layers = {};
        const decoded = MltDecoder_1.MltDecoder.decodeMlTile(data, featureTables);
        for (const layerName of Object.keys(decoded.layers)) {
            this.layers[layerName] = new VectorTileLayer_1.VectorTileLayer(decoded.layers[layerName]);
        }
    }
}
exports.VectorTile = VectorTile;
//# sourceMappingURL=VectorTile.js.map